function setSearchCategories(categories, [selected='']){
	[...document.querySelectorAll('ekm-search-categories')].forEach(el => {
		el.options = categories;
		el.value = selected;
	});
}

export class SearchCategoriesController {
	constructor(store){
		this._store = store;

		var state = store.getState();

		setSearchCategories(state.topLevelCategories, state.search.categories);

		store.subscribe(this._stateChange.bind(this));

		window.addEventListener('search-category-change', this._onCategoryChange.bind(this));
	}

	_stateChange(state){
		setSearchCategories(state.topLevelCategories, state.search.categories);
	}

	_onCategoryChange(event){
		var categories = []

		if (event.detail.value) categories.push(event.detail.value);

		this._store.dispatch({
			type: 'CHANGE_CATEGORY_FILTER',
			categories
		});
	}
}